import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  BarChartOutlined,
  CalendarOutlined,
  EyeOutlined,
  PlusOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Layout, Row, Space, Statistic, Typography } from "antd";
import { UserContext } from "@/Context/UserContext";

const { Title, Text } = Typography;
const { Content } = Layout;

export const Home = () => {
  const navigate = useNavigate();
  const { userProfileData } = useContext(UserContext);

  const dashboardCards = [
    {
      title: "Total Events",
      value: 0,
      icon: <CalendarOutlined style={{ fontSize: "24px", color: "#1890ff" }} />,
      color: "#e6f7ff",
    },
    {
      title: "Active Users",
      value: 1,
      icon: <UserOutlined style={{ fontSize: "24px", color: "#52c41a" }} />,
      color: "#f6ffed",
    },
    {
      title: "This Month",
      value: 0,
      icon: <BarChartOutlined style={{ fontSize: "24px", color: "#fa8c16" }} />,
      color: "#fff7e6",
    },
    {
      title: "Settings",
      value: "Configure",
      icon: <SettingOutlined style={{ fontSize: "24px", color: "#722ed1" }} />,
      color: "#f9f0ff",
      isAction: true,
      onClick: () => navigate("/settings"),
    },
  ];

  const quickActions = [
    {
      title: "Create Event",
      description: "Create a new calendar event",
      icon: <PlusOutlined />,
      onClick: () => navigate("/events"),
      type: "primary",
    },
    {
      title: "View Events",
      description: "View and manage your events",
      icon: <EyeOutlined />,
      onClick: () => navigate("/events"),
      type: "default",
    },
    {
      title: "Pricing",
      description: "Explore pricing plans",
      icon: <BarChartOutlined />,
      onClick: () => navigate("/pricing"),
      type: "default",
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f5f5" }}>
      <Content style={{ padding: "24px" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {/* Welcome Section */}
          <div>
            <Title level={2}>Welcome back, {userProfileData?.name || userProfileData?.email || "User"}! 👋</Title>
            <Text type="secondary" style={{ fontSize: "16px" }}>
              Here's what's happening with your calendar app today.
            </Text>
          </div>

          {/* Statistics Cards */}
          <Row gutter={[16, 16]}>
            {dashboardCards.map((card, index) => (
              <Col xs={24} sm={12} md={6} key={index}>
                <Card
                  hoverable={card.isAction}
                  style={{
                    background: card.color,
                    cursor: card.isAction ? "pointer" : "default",
                    height: "120px",
                  }}
                  onClick={card.onClick}
                  bodyStyle={{ padding: "20px" }}
                >
                  <Row align="middle" justify="space-between">
                    <Col>
                      <Statistic
                        title={card.title}
                        value={card.value}
                        valueStyle={{
                          color: card.isAction ? "#722ed1" : "inherit",
                          fontSize: card.isAction ? "16px" : "24px",
                        }}
                      />
                    </Col>
                    <Col>{card.icon}</Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Quick Actions */}
          <div>
            <Title level={3}>Quick Actions</Title>
            <Row gutter={[16, 16]}>
              {quickActions.map((action, index) => (
                <Col xs={24} sm={12} md={8} key={index}>
                  <Card hoverable style={{ height: "140px" }}>
                    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                      <div style={{ textAlign: "center", fontSize: "32px", color: "#1890ff" }}>{action.icon}</div>
                      <div style={{ textAlign: "center" }}>
                        <Title level={4} style={{ margin: 0 }}>
                          {action.title}
                        </Title>
                        <Text type="secondary">{action.description}</Text>
                      </div>
                      <Button type={action.type} block onClick={action.onClick}>
                        Get Started
                      </Button>
                    </Space>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          {/* Recent Activity */}
          <div>
            <Title level={3}>Recent Activity</Title>
            <Card>
              <div style={{ textAlign: "center", padding: "40px" }}>
                <CalendarOutlined style={{ fontSize: "48px", color: "#d9d9d9" }} />
                <Title level={4} type="secondary" style={{ marginTop: "16px" }}>
                  No recent activity
                </Title>
                <Text type="secondary">Start by creating your first event or exploring the features.</Text>
              </div>
            </Card>
          </div>
        </Space>
      </Content>
    </Layout>
  );
};

export default Home;
